<template>
    <div>
        <v-card raised class="mx-auto" max-width="570px">
            <form @submit.prevent="forgetPassword">
                <v-card elevation="0" class="white--text" color="#004236">
                    <v-card-title class="text-h5">Reset Password</v-card-title>
                </v-card>
                <v-card-text v-if="reset">
                    <v-card-subtitle>
                        A link to reset your password will be sent to the account email you enter below.
                    </v-card-subtitle>
                    <v-text-field
                        label="Account Email"
                        v-model="currentUser.email"
                        outlined
                        prepend-icon="mdi-email"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex justify-end">
                        <v-btn type="submit" dark color="#004236">Reset password</v-btn>
                    </v-col>
                </v-card-text>
                <v-card-text v-else>
                    <br />
                    <v-btn block dark color="#004236" to="/signin">Go back to Sign In</v-btn>
                    <br />
                </v-card-text>
            </form>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import firebase from "firebase";
require('firebase/auth')

export default {
    data() {
        return {
            currentUser: {   
                email: ''
            },
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 4000,
            reset: true
        };
    },
    methods: {
        forgetPassword() {
            firebase
            .auth()
            .sendPasswordResetEmail(this.currentUser.email)
            .then(() => {
                this.setSnackbar("Please check your email to reset password", "#1B5E20");
                this.user = {   
                    email: ''
                }
                this.reset = false;
            }).catch((error) => {
                this.setSnackbar("We cannot find the account with the entered email.", "#D32F2F");
                this.user = {   
                    email: ''
                }
            })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }
};
</script>